import React from "react";
import { cn } from "@/lib/utils";

export const AcaiLogo = ({ className, compact = false }) => (
  <div className={cn("acai-logo-wrap", compact && "acai-logo-compact", className)} aria-label="ACAI Agencive AI">
    <img src="/assets/acai-logo-white-transparent.png" alt="ACAI Agencive AI" className="acai-logo-image" />
  </div>
);

// Use the actual first letter of the existing wordmark, not a substitute font.
export const AcaiMark = () => (
  <svg className="acai-mark-logo" viewBox="0 0 305 280" aria-hidden="true" focusable="false">
    <image href="/assets/acai-logo-white-transparent.png" width="976" height="366" />
  </svg>
);

export const AnimatedAcaiLogo = () => {
  const id = React.useId().replace(/:/g, "");
  const parts = [[0, 305], [305, 223], [528, 300], [828, 148]];
  return <svg className="opening-wordmark" viewBox="0 0 976 366" aria-hidden="true" focusable="false">
    <defs>
      {parts.map(([x, width], index) => <clipPath id={`${id}-letter-${index}`} key={index}><rect x={x} y="0" width={width} height="280" /></clipPath>)}
      <clipPath id={`${id}-signature`}><rect x="0" y="280" width="976" height="86" /></clipPath>
    </defs>
    {parts.map((_, index) => <g key={index} clipPath={`url(#${id}-letter-${index})`}>
      <g className="opening-letter" style={{ animationDelay: `${index * 140}ms` }}><image href="/assets/acai-logo-white-transparent.png" width="976" height="366" /></g>
    </g>)}
    <g clipPath={`url(#${id}-signature)`} className="opening-signature"><image href="/assets/acai-logo-white-transparent.png" width="976" height="366" /></g>
  </svg>;
};
